"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIPopoverHeader = _interopRequireDefault(require("UIComponents/tooltip/UIPopoverHeader"));

var _UIFieldset = _interopRequireDefault(require("UIComponents/form/UIFieldset"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _image = require("../../constants/image");

var _popover = require("../../constants/popover");

var _alignments = require("../../constants/alignments");

var _spacing = require("../../constants/spacing");

var _iterables = require("../../utils/iterables");

var _LinkFields = _interopRequireDefault(require("../links/LinkFields"));

var _StyleControls = _interopRequireDefault(require("../StyleControls"));

var _FormLabelWithHelpLink = _interopRequireDefault(require("../FormLabelWithHelpLink"));

var _ImagePreview = _interopRequireDefault(require("./ImagePreview"));

var i18nKey = function i18nKey(key) {
  return "RichTextLib.image." + key;
};

var i18nAlignmentKey = function i18nAlignmentKey(key) {
  return "RichTextLib.image.alignment." + key;
};

var CONTENT_TAB = _image.ImagePopoverTabs.CONTENT_TAB,
    STYLE_TAB = _image.ImagePopoverTabs.STYLE_TAB,
    LINK_TAB = _image.ImagePopoverTabs.LINK_TAB;

var EditImagePopoverBody = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditImagePopoverBody, _Component);

  function EditImagePopoverBody() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, EditImagePopoverBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(EditImagePopoverBody)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.altTextInputRef = _react.default.createRef();

    _this.handleKeyDown = function (evt) {
      if (evt.key === _popover.KeyTypes.ESCAPE) {
        _this.props.onClose();
      }
    };

    _this.handleUrlKeyDown = function (evt) {
      if (evt.key === _popover.KeyTypes.ENTER) {
        _this.props.onClose();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(EditImagePopoverBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Autofocusing the text input needs to be delayed so that the popover
      // is properly positioned before we focus to avoid jumpiness when the browser
      // scrolls the focused field into view.
      //
      // If browsers supported `preventScroll` across the board, we could use that.
      this.focusTimeout = setTimeout(function () {
        if (_this2.props.popoverTab === CONTENT_TAB) {
          _this2.altTextInputRef.current.focus();
        }
      });
    }
  }, {
    key: "componentWillUnount",
    value: function componentWillUnount() {
      clearTimeout(this.focusTimeout);
    }
  }, {
    key: "renderContentTab",
    value: function renderContentTab() {
      var _this3 = this;

      return _react.default.createElement(_UITab.default, {
        tabId: CONTENT_TAB,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('tabContent')
        })
      }, _react.default.createElement(_FormLabelWithHelpLink.default, {
        primaryText: i18nKey('imagePreviewLabel'),
        linkText: i18nKey('replace'),
        onLinkClick: this.props.onSrcChange
      }), _react.default.createElement(_ImagePreview.default, {
        src: this.props.src
      }), _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('altTextLabel')
        }),
        tooltip: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('altTextHelp')
        })
      }, _react.default.createElement(_UITextInput.default, {
        inputRef: this.altTextInputRef,
        name: "alt-text",
        value: this.props.altText,
        onChange: function onChange(_ref) {
          var target = _ref.target;
          return _this3.props.onAltTextChange(target.value);
        }
      })));
    }
  }, {
    key: "renderStyleTab",
    value: function renderStyleTab() {
      return _react.default.createElement(_UITab.default, {
        tabId: STYLE_TAB,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('tabStyle')
        })
      }, _react.default.createElement(_StyleControls.default, Object.assign({}, (0, _iterables.pick)(['dimensions', 'maxDimensions', 'naturalWidth', 'naturalHeight', 'onDimensionsChange', 'margin', 'onMarginChange', 'showDimensionsControls', 'showMarginControls', 'staticPrefix', 'useAlignmentIconButtons'], this.props), {
        i18nAlignmentKey: i18nAlignmentKey,
        alignment: this.props.alignment || _alignments.Alignments.NONE,
        onChangeAlignment: this.props.onLayoutChange,
        spacingIconType: _spacing.SpacingIconTypes.IMAGE
      })));
    }
  }, {
    key: "renderLinkTab",
    value: function renderLinkTab() {
      return _react.default.createElement(_UITab.default, {
        tabId: LINK_TAB,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('tabLink')
        })
      }, _react.default.createElement(_LinkFields.default, Object.assign({}, (0, _iterables.pick)(Object.keys(_LinkFields.default.propTypes), this.props), {
        onUrlKeyDown: this.handleUrlKeyDown
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIFieldset.default, {
        onKeyDown: this.handleKeyDown,
        className: "large-popover-body",
        _size: "small",
        tabIndex: "-1"
      }, _react.default.createElement(_UIPopoverHeader.default, {
        className: "p-bottom-5"
      }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('popoverTitle')
      }))), _react.default.createElement(_UICloseButton.default, {
        onClick: this.props.onClose,
        color: _colors.EERIE,
        className: "hs-close-button"
      }), _react.default.createElement(_UITabs.default, {
        wrapperClassName: "edit-popover-body__tabs",
        use: "flush",
        defaultSelected: this.props.popoverTab || CONTENT_TAB,
        fill: true
      }, this.renderContentTab(), this.renderStyleTab(), this.renderLinkTab()));
    }
  }]);
  return EditImagePopoverBody;
}(_react.Component);

exports.default = EditImagePopoverBody;
EditImagePopoverBody.propTypes = Object.assign({
  popoverTab: _propTypes.default.string,
  onDimensionsChange: _propTypes.default.func,
  onClose: _propTypes.default.func.isRequired,
  onSrcChange: _propTypes.default.func.isRequired,
  altText: _propTypes.default.string,
  onAltTextChange: _propTypes.default.func,
  margin: _propTypes.default.object,
  onMarginChange: _propTypes.default.func,
  staticPrefix: _propTypes.default.string.isRequired,
  onLayoutChange: _propTypes.default.func.isRequired,
  alignment: _propTypes.default.oneOf(Object.keys(_alignments.Alignments).map(function (key) {
    return _alignments.Alignments[key];
  })),
  src: _propTypes.default.string.isRequired
}, (0, _iterables.omit)(['onUrlKeyDown'], _LinkFields.default.propTypes), {
  // Dimensions propTypes (not directly imported to exclude .required)
  dimensions: _propTypes.default.shape({
    height: _propTypes.default.number.isRequired,
    width: _propTypes.default.number.isRequired
  }),
  maxDimensions: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number
  }),
  showDimensionsControls: _propTypes.default.bool,
  showMarginControls: _propTypes.default.bool,
  naturalHeight: _propTypes.default.number,
  naturalWidth: _propTypes.default.number
});
EditImagePopoverBody.defaultProps = {
  showDimensionsControls: false,
  showMarginControls: false
};
module.exports = exports.default;